/**
 * Galerie – lightbox nad odkazy s třídou .glightbox.
 *
 * GLightbox NENÍ v hlavním bundlu — stahuje se až při prvním kliknutí na fotku
 * (16 kB gzip, které by jinak platil každý návštěvník včetně těch, co na galerii
 * nikdy nedojedou). Odkazy vedou na plnou fotku, takže bez JS nebo když se
 * knihovna nestáhne, obrázek se prostě otevře v novém okně.
 *
 * Přístupnost: při prefers-reduced-motion vypínáme přechody mezi snímky
 * (WCAG 2.3.3 Animation from Interactions).
 */
import { loadVendor, loadStyle } from './lazy-vendor.js';

const GLIGHTBOX = '/www/assets/js/vendor/glightbox/glightbox.min.js';

/** Spustí lightbox nad odkazy .glightbox. Volá se až po stažení knihovny. */
function spustGalerii() {
    if (typeof GLightbox === 'undefined') return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    return GLightbox({
        selector: '.glightbox',
        loop: true,
        touchNavigation: true,
        openEffect: reduceMotion ? 'none' : 'zoom',
        closeEffect: reduceMotion ? 'none' : 'zoom',
        slideEffect: reduceMotion ? 'none' : 'slide',
    });
}

async function initGallery() {
    const odkazy = document.querySelectorAll('.glightbox');
    if (!odkazy.length) return;          // na stránce galerie není – nestahuj nic

    // První kliknutí odchytíme sami: stáhneme knihovnu, necháme ji převzít
    // odkazy a rovnou otevřeme tu fotku, na kterou návštěvník klikl. Bez toho
    // by první klik jen otevřel obrázek v novém okně a lightbox by naskočil
    // až napodruhé.
    const naKlik = async (event) => {
        event.preventDefault();
        const odkaz = event.currentTarget;

        const [ok] = await Promise.all([loadVendor(GLIGHTBOX), loadStyle('gallery')]);
        if (!ok) {
            window.open(odkaz.href, '_blank', 'noopener');   // knihovna nedorazila
            return;
        }

        odkazy.forEach((a) => a.removeEventListener('click', naKlik));
        const lightbox = spustGalerii();
        lightbox?.openAt([...odkazy].indexOf(odkaz));
    };

    odkazy.forEach((a) => a.addEventListener('click', naKlik));
}

document.addEventListener('DOMContentLoaded', initGallery);
